import { round2 } from "./money";

/**
 * Resolves the payment state from the method and the typed cash amount.
 *
 * Shared by the payment controls, the pinned complete button and the sale
 * submission, so "empty means exact" is decided in exactly one place.
 */
/**
 * Whether a credit sale knows whose tab it goes on: a scanned card, or a tab
 * picked or named at the till.
 */
export const hasTab = (customer, creditTab) =>
  Boolean(customer || creditTab?.name?.trim());

export const paymentState = (method, tendered, total, tabChosen = true) => {
  const isCash = method === "cash";
  const isCredit = method === "credit";
  const tenderedValue = parseFloat(tendered) || 0;
  // An empty field defaults differently per method: the exact total for
  // cash/card, but nothing at all up front for credit — a tab can be opened
  // for the whole ticket without typing a number.
  const hasTendered = (isCash || isCredit) && tendered !== "" && tenderedValue > 0;
  // Credit can still take a partial payment up front — the owner gets part
  // of it now and the rest stays on the tab — unlike card/mobile which are
  // always treated as paid in full immediately.
  const amountPaid = isCredit
    ? hasTendered
      ? round2(Math.min(tenderedValue, total))
      : 0
    : hasTendered
      ? round2(tenderedValue)
      : round2(total);

  return {
    isCash,
    isCredit,
    hasTendered,
    amountPaid,
    // What's left on the tab after whatever was collected up front.
    creditRemaining: isCredit ? round2(Math.max(total - amountPaid, 0)) : 0,
    changeDue: isCredit ? 0 : round2(Math.max(amountPaid - total, 0)),
    isShort: isCash && hasTendered && tenderedValue < total,
    // A tab is owed by somebody specific, so credit stays blocked until the
    // ticket names whose it is — same rule the server enforces.
    isCreditBlocked: isCredit && !tabChosen,
  };
};
